import {ChangeDetectorRef, Component, NgZone, OnInit} from '@angular/core';
import {BaseCrudComponent} from "../../base-crud/base-crud.component";
import {ApiService} from "../../../providers/main/api.service";
import {NgbDatepickerNavigateEvent, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Storage} from "@ionic/storage";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {ScriptService} from "../../../script.service";
import {DatePipe} from "@angular/common";
import {concat, of, from} from "rxjs";
import {catchError, mergeMap} from "rxjs/operators";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import Swal from "sweetalert2";
declare let pdfMake: any ;
import * as moment from 'moment-timezone';
import { Modal } from 'bootstrap';
import { saveAs as importedSaveAs } from "file-saver";

@Component({
  selector: 'app-extract-data',
  templateUrl: './extract-data.component.html',
  styleUrls: ['./extract-data.component.css'],
  providers: [DatePipe]
})
export class ExtractDataComponent extends BaseCrudComponent implements OnInit {
  private modal: Modal | undefined;
  id: any;
  cargaExcel = true;
  isButtonDisabled: boolean = false;
  comissionRN = [];
  listAgr: any;
  translations: any;
  currentcountry: any;

  currentMonth: number;
  currentYear: number;

  degrees:any;
  positions:any;
  parentagents:any;
  childagents:any;
  parentcustomers:any;
  childcustomers:any;
  childcustomers2:any;

  subagents = [];
  sublines = [];
  groups = [];
  lines = [];
  childlines = [];

  displayedColumns: string[] = ['Id','Name','Email'];
  monthList = [
    { Value: "01", Text: 'Enero' },
    { Value: "02", Text: 'Febrero' },
    { Value: "03", Text: 'Marzo' },
    { Value: "04", Text: 'Abril' },
    { Value: "05", Text: 'Mayo' },
    { Value: "06", Text: 'Junio' },
    { Value: "07", Text: 'Julio' },
    { Value: "08", Text: 'Agosto' },
    { Value: "09", Text: 'Septiembre' },
    { Value: "10", Text: 'Octubre' },
    { Value: "11", Text: 'Noviembre' },
    { Value: "12", Text: 'Diciembre' }
  ];
  yearList = [
    { Value: 2014, Text: '2014' },
    { Value: 2015, Text: '2015' },
    { Value: 2016, Text: '2016' },
    { Value: 2017, Text: '2017' },
    { Value: 2018, Text: '2018' },
    { Value: 2019, Text: '2019' },
    { Value: 2020, Text: '2020' },
    { Value: 2021, Text: '2021' },
    { Value: 2022, Text: '2022' },
    { Value: 2023, Text: '2023' },
    { Value: 2024, Text: '2024' },
    { Value: 2025, Text: '2025' },
    { Value: 2026, Text: '2026' },
    { Value: 2027, Text: '2027' },
    { Value: 2028, Text: '2028' },
    { Value: 2029, Text: '2029' },
    { Value: 2030, Text: '2030' }
  ];
  myDate = new Date();
  myDateFormat:any;

  momentjs: any = moment;
  last_sync:any;

  hideme = [];
  hideme2 = [];
  Index: any;
  Index2: any;
  showDiv = {
    cobro : false,
    factura : false,
    cartera : false
  }
  constructor(
    private cdRef: ChangeDetectorRef,
    private zone: NgZone,
    srv: ApiService,
    modalService: NgbModal,
    storage: Storage,
    router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private scriptService: ScriptService,
    public api: ApiService,
    private datePipe: DatePipe
  ) {
    super(srv, modalService, storage, router);
    this.id = route.snapshot.params.id;

    const currentDate = new Date();
    this.currentMonth = currentDate.getMonth() + 1; // Los meses van de 0 a 11
    this.currentYear = currentDate.getFullYear();
    console.log("mes",this.currentMonth +"/"+ this.currentYear)

    this.read_url = 'ExceptionHandling/All';
    this.create_url = 'ExceptionHandling/Create';
    this.update_url = 'ExceptionHandling/Update';
    this.createorupdate_url = 'PortfolioByAgent/CreateOrUpdatePortfolioByAgent';
    this.delete_url = 'ExceptionHandling/LogicalDelete';
    this.search_fields = ['IdAgent', 'AgentName'];

    this.c_obj['SiteAddress'] = [];

    this.reload.subscribe(val => {
      if( val ){
        super.clearData();
        //this.getList();
      }
    });
    this.c_obj['TotalGlobal'] = 0;
    storage.get('current_country').then(x => {
      this.currentcountry = x? x : "EC";
    });

    console.log('Loading External Scripts');
    this.scriptService.load('pdfMake', 'vfsFonts');
    this.myDateFormat = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
  }

  selectedFile: File | null = null;
  archivos: any;
  namefile: any;
  onFileSelected(e: any): void {debugger;
    this.selectedFile = e.target.files[0];
    this.archivos = [];
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

    // const archivocapture = e.target.files[0];
    this.archivos.push(this.selectedFile);
    this.namefile = file.name;
  }
  ngOnInit() {
    this.translate.getTranslation(this.translate.currentLang)
      .subscribe((translations) => {
        this.translations = translations;
        super.ngOnInit();
        // var qs = 'CommissionResult/CommissionResultNew';
        // this.srv.getCall(qs).subscribe(crn => {
        //   this.comissionRN = crn.val;
        // });

        var batch = [];
        //batch.push(this.getDegrees());
        //batch.push(this.getPositions());
        batch.push(this.getParentAgents());
        batch.push(this.getChildAgents());
        batch.push(this.getParentCustomers());
        batch.push(this.getGroups());
        batch.push(this.getChildCustomers2());

        this.loadingList = true;
        const current = new Date();
        // current.setMonth(current.getMonth()-1);
        this.c_obj['agrYear'] = current.getFullYear();
        this.c_obj['agrMonth'] = (current.getMonth() + 1).toString().padStart(2, '0');
        this.c_obj['agrAllAnalysis'] = 2;
        this.showData()
        // concat(...batch).subscribe({
        //   complete: () => {
        //     this.loadingList = false;
        //     //this.getList();
        //     this.showData()
        //   }
        // });
      });

    // Inicializar el modal cuando el componente se cargue
    const modalElement = document.getElementById('fileUploadModal');
    if (modalElement) {
      this.modal = new Modal(modalElement); // Inicializa el modal con el id del modal
    }
  }

  onValueChange(row: any){
// Asegúrate de que no haya división por cero
    var suma = (row.TotalOverdue + row.TotalToExpire);
    if (suma > 0) {
      row.PercentageOverduePortfolio = parseFloat(((row.TotalOverdue / suma) * 100).toFixed(2));
    } else {
      row.PercentageOverduePortfolio = 0;  // Si alguno es 0, no se puede calcular el porcentaje
    }
  }

  openModal(): void {
    if (this.modal) {
      this.modal.show(); // Muestra el modal
    }
  }
  closeModal2(): void {
    if (this.modal) {
      this.modal.hide(); // Cierra el modal
    }
  }
  // Metodo que verifica si se puede editar

  isDisabled:any = true;
  public cargarExcel() {debugger;
    this.closeModal2();
    this.isCreating = true; // Inicia el spinner
    this.isDisabled = true; // Asegura que el botón esté habilitado al inicio
    if (!this.selectedFile) {
      Swal.fire('Error', 'Por favor selecciona un archivo para cargar.', 'error');
      this.isCreating = false;
      this.isDisabled = true;
      return;
    }
    const formData = new FormData();
    debugger;
    // Agregar el archivo al FormData
    if (this.archivos && this.archivos[0]) {
      formData.append('FileUpload', this.archivos[0]); // 'FileUpload' es el nombre esperado en el backend
    }

    // Agregar los datos adicionales al FormData
    formData.append('rutaPdf', this.selectedFile.name);
    formData.append('fileName', this.selectedFile.name);
    formData.append('currentcountry', this.currentcountry);
    formData.append('month', this.c_obj['agrMonth']);
    formData.append('year', this.c_obj['agrYear']);

    // Agregar campos adicionales desde "fields"
    /*for (const [key, value] of Object.entries(fields)) {
      formData.append(key, value as string);
    }*/

    // Extraer el número de orden del archivo
    const orderNumberFromFile = this.selectedFile.name.match(/OC(\d+)/);
    const orderNumberOnly = orderNumberFromFile ? orderNumberFromFile[1] : null;
    console.log('OrderNumber extraído del archivo PDF:', orderNumberOnly);

    // Verificar si el nombre del archivo coincide con algún OrderNumber en rows
    const matchingRecord = this.rows.find((record: any) => {
      return record.OrderNumber && record.OrderNumber.toString().includes(orderNumberOnly);
    });

    if (!matchingRecord) {
      var qst = 'ExceptionHandling/CargarExcel/';

      // Mostrar el mensaje "Procesando archivo Excel"
      Swal.fire({
        title: 'Procesando archivo Excel',
        text: 'Por favor espere...',
        icon: 'info',
        showConfirmButton: false, // No mostrar el botón de confirmar
        allowOutsideClick: false, // No permitir que el usuario cierre la alerta
        didOpen: () => {
          Swal.showLoading();
        }
      });
      // Enviar el FormData a través de postCall
      this.isCreating = true;debugger
      this.srv.postCallWithData(qst, formData).subscribe(
        x => {debugger;
          this.isCreating = false;
          // const msg = this.translateMessage(x.msg);
          if (x.success) {
            debugger
            console.log('Orden y detalles guardados con éxito:', x);
            Swal.fire('¡Éxito!', x.msg, 'success').then(() => {
              // Redirige a la página de órdenes de compra
              //this.closeModal(content);
              //this.router.navigate(['/purchaseorderex']);
              //this.eventPurchaseP.emit();
              this.showData(); // Llamada activada
            });
            //this.reload.next(true);
            // Swal.fire('¡Creado!', msg, 'success');

          } else {
            console.error('Error en la respuesta de la API:', x.msg);
            this.isDisabled = true; // Bloquear botón al recibir un error
            Swal.fire('Error', x.msg || 'Hubo un problema al cargar el archivo', 'error');
          }
        },
        error => {
          this.isCreating = false; // Detiene el spinner
          this.isDisabled = true;  // Bloquea el botón
          // Verificar si el error tiene un mensaje de excepción
          if (error && error.error && error.error.ExceptionMessage) {
            // Mostrar el mensaje de excepción retornado por el backend
            Swal.fire('Error', error.error.ExceptionMessage, 'error');
          } else {
            // Si no hay un mensaje de excepción, mostrar un error genérico
            Swal.fire('Error', 'Ocurrió un problema en el servidor.', 'error');
          }
        }
      );
    } else {
      this.isCreating = false; // Detiene el spinner
      this.isDisabled = true;  // Bloquea el botón
      // Si se encuentra la coincidencia, mostrar error
      Swal.fire('Error', 'Se encontró un registro con ese número de orden.', 'error');
    }
  }
  // Metodo para abrir el modal usando Bootstrap
  public getList(){debugger
    var qst = this.read_url;
    this.loadingList = true;
    this.srv.getCall(qst).subscribe(x => {
      this.loadingList = false;

      if(x.success){
        x.val.forEach(y => {
          y['name'] = y['FirstName'] + ' ' + y['LastName'];
        });

        this.rawdata = x.val;
        this.rows = x.val;
        this.page = 1;

        if( Array.isArray(this.rows) ){
          this.pageTotal = this.rows.length;
        }
      }
    });
  }
  public getMasterData(){
    Swal.fire({
      title: this.translations.masterdata_confirm,
      text: '',
      icon: 'warning',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      cancelButtonText: this.translations.cancel,
      confirmButtonText: this.translations.ok,
      /*preConfirm: () => {
        this.getCompanyData().subscribe(c => {
          Swal.fire(this.translations.updated, '', 'success');
        });//end company data
      }*/
    }).then((result) => {

    });

  }

  public getCompanyData(){
    //var ent_url = 'PathologicalDataInput/PathologicalEntities';
    var ent_url = 'Invoice/GetM3Data/'+this.c_obj['agrMonth']+'-'+this.c_obj['agrYear'];
    //url = 'InvoiceBilling/AllByYearMonth/'+this.c_obj['agrMonth']+'-'+this.c_obj['agrYear'];
    return this.api.getCall(ent_url).pipe(
      mergeMap(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;

        if(mydata.success == true ){
          //return of(mydata.result.accessToken);
          this.last_sync = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD hh:mm');
          this.api.persistData('md_lastsync', this.last_sync);
          return from(this.api.persistData('companies', mydata.val));
        }
        else{
          return of(false);
        }
      }),
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }

  public getVal(obj:any, key:any){
    let resp = '';
    if( (obj !== undefined) && (obj !== null) ){
      resp = obj[key];
    }
    return resp;
  }

  public getFromArray(arr:any, key:any, val:any, to:any, def:any){
    let resp = arr.filter(f => {
      return f[key] == val;
    });

    return (resp.length > 0) ? resp[0][to] : def;
  }

  public getGroups(){
    let url = 'Line/AllGroups';
    return this.srv.getCall(url).pipe(
      mergeMap(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;
        //debugger;
        if(mydata.success == true ){
          this.groups = mydata.val;
          return of(true);
        }
        else{
          return of(false);
        }
      }),
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }
  public getLines(linegroupId){
    let url = 'Line/AllLite';
    return this.srv.getCall(url).subscribe(data => {
      let mydata:any = {success: false, msg:'', val:[]};
      mydata = data;
      //debugger;
      if(mydata.success == true ){
        this.lines = mydata.val.filter((item) => item.IdLineGroup == linegroupId);
        return of(true);
      }
      else{
        return of(false);
      }
    }),
      //timeout(MAX_TIME),
      catchError(data => of(false));
  }
  /*onSelect(countryid) {
    this.states = this.selectService.getStates().filter((item) => item.countryid == countryid);
  }*/
  public getChildlines(lineid){

    let url = 'Subline/AllLite';
    return this.srv.getCall(url).
    subscribe(data => {
      let mydata:any = {success: false, msg:'', val:[]};
      mydata = data;
      //console.log(mydata);
      debugger;
      if(mydata.success == true ){
        this.childlines = mydata.val.filter((item) => item.IdLine == lineid);
        return of(true);
      }
      else{
        return of(false);
      }
    }),
      //timeout(MAX_TIME),
      catchError(data => of(false));
  }
  public getChildAgents(){
    let url = 'Agent/AllUnassignedType';
    return this.srv.getCall(url).pipe(
      mergeMap(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;
        //debugger;
        if(mydata.success == true ){
          this.childagents = mydata.val;
          return of(true);
        }
        else{
          return of(false);
        }
      }),
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }
  public getParentAgents(){
    let url = 'Agent/AllAssignedType';
    return this.srv.getCall(url).pipe(
      mergeMap(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;
        //debugger;
        if(mydata.success == true ){
          this.parentagents = mydata.val;
          return of(true);
        }
        else{
          return of(false);
        }
      }),
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }
  public getParentCustomers(){
    let url = 'CustomerGroup/AllLite';
    return this.srv.getCall(url).pipe(
      mergeMap(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;
        //debugger;
        if(mydata.success == true ){
          this.parentcustomers = mydata.val;
          return of(true);
        }
        else{
          return of(false);
        }
      }),
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }
  public getChildCustomers2(){
    debugger;
    let url = 'Customer/AllLite';
    return this.srv.getCall(url).pipe(
      mergeMap(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;
        //debugger;
        if(mydata.success == true ){
          this.childcustomers2 = mydata.val;
          return of(true);
        }
        else{
          return of(false);
        }
      }),
      //timeout(MAX_TIME),
      catchError(data => of(false)));
  }

  public getChildCustomers(customergroupId){
    debugger;
    let url = 'Customer/AllLite';
    return this.srv.getCall(url).subscribe(data => {
      let mydata:any = {success: false, msg:'', val:[]};
      mydata = data;
      //debugger;
      if(mydata.success == true ){
        this.childcustomers = mydata.val.filter((item) => item.IdCustomerGroup == customergroupId);
        this.childcustomers2 = mydata.val.filter((item) => item.IdCustomerGroup == customergroupId);
        return of(true);
      }
      else{
        return of(false);
      }
    }),
      //timeout(MAX_TIME),
      catchError(data => of(false));
  }

  public getDegrees(){
    let url = 'SystemParameter/GetByName/USR_DEG';
    return this.srv.getCall(url).pipe(
      mergeMap(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;

        if(mydata.success == true ){
          this.degrees = mydata.val[0];
          return of(true);
        }
        else{
          return of(false);
        }
      }),
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }

  public showSubAgentsInfo(index, idAgent){
    let url = 'InvoiceDetail/AllDetailsByIdInvoice/'+idAgent;
    return this.srv.getCall(url).subscribe(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;
        //debugger;
        if(mydata.success == true ){
          this.subagents[index] = mydata.val;
          this.hideme[index] = !this.hideme[index];
          this.Index = index;
          return of(true);
        }
        else{
          return of(false);
        }
      },
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }
  public showProductCountryInfo(index, idParentAgent, idAgent) {
    let url = 'AgentGrouping/AllSubLinesByIdAgent/'+idParentAgent+'/'+idAgent;
    return this.srv.getCall(url).subscribe(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;
        //debugger;
        if(mydata.success == true ){
          this.sublines[index] = mydata.val;
          this.hideme2[index] = !this.hideme2[index];
          this.Index2 = index;
          return of(true);
        }
        else{
          return of(false);
        }
      },
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }
  public getPositions(){
    let url = 'SystemParameter/GetByName/USER_POS';
    return this.srv.getCall(url).pipe(
      mergeMap(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;

        if(mydata.success == true ){
          this.positions = mydata.val[0];
          return of(true);
        }
        else{
          return of(false);
        }
      }),
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }
  validateCreateInfo(fields:any){
    let mygroup:any = {};
    mygroup = new FormGroup({
      'IdAgent': new FormControl(fields.IdAgent, [Validators.required])
    });

    return mygroup.valid;
  }
  public createItem(content:any, form:any){
    var validated = true;

    if( form == undefined ){
      form = {};
    }
//debugger;
    validated = this.validateCreateInfo(form);
    if( !validated ){
      Swal.fire(this.translations['msg_all_required'], '', 'error');
      return;
    }

    var to:any;
    to = form;

    var qst = this.create_url;
    this.isCreating = true;

    this.srv.postCall(qst, to).subscribe(x => {
      this.isCreating = false;
      if(x.success){
        this.c_obj = {};
        this.getList();
        this.closeModal(content);
        //this.showProductCountryInfo(this.Index2, form["IdParentAgent"], form["IdAgent"]);
        Swal.fire('¡Creado!', 'Registro creado correctamente', 'success');
      }//end success
      else{
        //Swal.fire(this.translations[x.msg], '', 'error');
        Swal.fire(x.msg, '', 'error');
      }
    });
  }

  public crearorupdateItem(form:any){
    var validated = true;

    if( form == undefined ){
      form = {};
    }

    console.log("fromm", form);
    var to:any;
    to = form;

    var qst = this.createorupdate_url;
    this.isUpdating = true;

    this.srv.postCall(qst, to).subscribe(x => {
      this.isUpdating = false;
      if(x.success){
        // this.getList();
        // this.showData();
        Swal.fire(this.translations['updated'], '', 'success').then((res)=>{
          this.showData();
        });
      }//end success
      else{
        Swal.fire(x.msg, '', 'error');
        //this.closeModal(content);
      }
    });
  }

  public updateItem(content:any, form:any){
    var validated = true;

    if( form == undefined ){
      form = {};
    }

    var to:any;
    to = form;

    var qst = this.update_url;
    this.isUpdating = true;

    this.srv.postCall(qst, to).subscribe(x => {
      this.isUpdating = false;
      if(x.success){
        this.getList();
        this.closeModal(content);
        Swal.fire(this.translations['updated'], '', 'success');
      }//end success
      else{
        Swal.fire(x.msg, '', 'error');
        //this.closeModal(content);
      }
    });
  }
  public deleteItem(obj: any, trans?:any) {
    var qst = this.delete_url;
    //console.log(trans);
    if( trans == undefined ){
      trans = {
        delete: 'Borrar',
        deleted: 'Borrado',
        cancel: 'Cancelar',
        delete_item_title: 'Está seguro que desea eliminar el registro?'
      };
    }

    Swal.fire({
      title: trans.delete_item_title,
      text: '',
      icon: 'warning',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      cancelButtonText: trans.cancel,
      confirmButtonText: trans.delete,
      preConfirm: () => {
        this.srv.postCall(qst, obj).subscribe(x => {
          let msg = this.translateMessage(x.msg);
          if(x.success){
            this.reload.next(true);
            this.hideme2[this.Index2] = !this.hideme2[this.Index2];
            Swal.fire(trans.deleted, msg, 'success');
          }
          else{
            Swal.fire(msg, '', 'error');
          }
        });
      }
    }).then((result) => {
    });
  }

  generatePdf(action='open'){
    console.log(pdfMake);
    const documentDefinition = this.getDocumentDefinition();

    switch (action) {
      case 'open': pdfMake.createPdf(documentDefinition).open(); break;
      case 'print': pdfMake.createPdf(documentDefinition).print(); break;
      case 'download': pdfMake.createPdf(documentDefinition).download(); break;

      default: pdfMake.createPdf(documentDefinition).open(); break;
    }
  }
  getDocumentDefinition() {
    return {
      // [left, top, right, bottom]
      pageMargins: [40, 95, 40, 90],
      header: {
        margin: 15, // 18
        columns: [
          [],
          {
            // por lo general, usaría un dataUri en lugar del nombre para la impresión del lado del cliente de
            // sampleImage.jpg, sin embargo, funciona dentro del ambiente para que pueda trabajar con él
            // image: 'assets/SkrettingLogo.png',
            // tslint:disable-next-line:max-line-length
            image: 'data:image/jpeg;base64,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',
            width: 110
          }
        ]
      },
      content: [
        {
          margin: [0, -60, 0, 0],
          fontSize: 10,
          text: [
            {text: 'Documento generado desde: ', fontSize: 10, bold: true}, 'PayCom']
        },
        {
          margin: [0, 0, 0, 0],
          fontSize: 10,
          text: [
            {text: 'El día: ', fontSize: 10, bold: true}, this.myDateFormat]
        },
        {
          text: 'Listado de grupos de clientes',
          bold: true,
          fontSize: 20,
          alignment: 'center',
          margin: [0, 35, 0, 20]
        },
        this.table(this.rows, ['IdAgent', 'AgentGroupName', 'AgentName'],[{text:'Código', fillColor: '#c8102e', color:'white', alignment: 'center', alignmentChild: 'right'},
          {text:'Tipo de Vendedor', fillColor: '#c8102e', color:'white', alignment: 'center', alignmentChild: 'right'},
          {text:'Nombre', fillColor: '#c8102e', color:'white', alignment: 'center', alignmentChild: 'right'}]),//
        {

          //style: 'tableExample',
          /*table: {
            margin: [0, 0, 0, 70],
            headerRows: 1,
            // dontBreakRows: true,
            // keepWithHeaderRows: 1,
            body: [
              [{text: 'Header 1', style: 'tableHeader'}, {text: 'Header 2', style: 'tableHeader'}, {text: 'Header 3', style: 'tableHeader'}],
              [
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
              ]
            ]
          }*/
        },
        {
          columns: [


          ]
        },

      ],
      pageBreakBefore: function (currentNode) { return currentNode.id === 'mediaRow' && currentNode.pageNumbers.length > 1; },
      info: {
        title: 'PayCom' + '_Clientes',
        author: 'PayCom',
        subject: 'Clientes',
        keywords: 'Clientes, ONLINE Clientes',
      },
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#68102e',
          color: '#ffffff',
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        tableExample: {
          margin: [0, 5, 0, 15]
        },
      },
      footer: [

        {
          // tslint:disable-next-line:max-line-length
          image: 'data:image/png;base64,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',
          //width: 90,
          x: 0,
          y: 30,
          w: 850, // landscape
          h: 70
          //margin: [10, -80, 0, 0] // -120 is your rect height
        },
        {
          text:'Skretting Ecuador | Km 4.5 & 6.5 vía Durán ” Tambo. Durán ” Ecuador | Telf: + 593 4 2598100 + 593 4 2815737',
          fontSize: 8,
          margin: [0, -93, 0, 0],
          alignment: 'center',
          color: '#686868'

          /*canvas: [
            {
              type: 'rect',
              x: 0,
              y: 10,
              w: 850, // landscape
              h: 80,
              color: '#b91600'
            }
          ]*/
        },
        {
          text: 'www.skretting.ec',
          link: 'www.skretting.ec',
          color: 'blue',
          fontSize: 8,
          margin: [0, 0, 0, 0],
          alignment: 'center'
        }
      ]

    };
  }
  public buildTableBody(data, columns, headers) {
    var body = [];
    body.push(headers);

    data.forEach(function(row) {
      var dataRow = [];


      columns.forEach(function(column) {
        if( row[column] != null){
          dataRow.push(row[column].toString());
        }
      })

      body.push(dataRow);
    });
    return body;
  }

  public table(data, columns, headers) {


    return {
      fontSize: 12,
      margin: [20, 20],
      //layout: 'lightHorizontalLines',
      style: 'tableExample',
      table: {
        headerRows: 1,
        body: this.buildTableBody(data, columns, headers)
      }
    };
  }

  dateNavigate($event: NgbDatepickerNavigateEvent) {
    console.log($event.next.month);
    console.log($event.next.year);

  }
  public async showData(){debugger
    let url = '';
    // if(this.currentcountry != ""){
    //   Swal.fire('Datos faltantes', 'Porfavor elija el país', 'warning');
    //   return
    // }
    // debugger;
    console.log('tipo: '+this.c_obj['agrAllAnalysis']);
    console.log('country: '+this.currentcountry);
    if (this.c_obj['agrAllAnalysis']==0){
      // this.showDiv.cobro = true;
      // this.showDiv.factura = false;
      // this.showDiv.cartera = false;

      url = 'InvoiceBilling/AllByYearMonth/'+this.c_obj['agrMonth']+'-'+this.c_obj['agrYear']+'-'+this.currentcountry;

    }else if (this.c_obj['agrAllAnalysis']==1){
      // this.showDiv.cobro = false;
      // this.showDiv.factura = true;
      // this.showDiv.cartera = false;

      url = 'Invoice/AllByYearMonth/'+this.c_obj['agrMonth']+'-'+this.c_obj['agrYear']+'-'+this.currentcountry;
    }else {
      // this.showDiv.cobro = false;
      // this.showDiv.factura = false;
      // this.showDiv.cartera = true;

      url = 'PortfolioByAgent/AllByYearMonth/'+this.c_obj['agrMonth']+'-'+this.c_obj['agrYear']+'-'+this.currentcountry;
    }
    this.srv.getCall(url).subscribe(data => {debugger
      if(data.success){
        var rs = data.val;
        this.rows = rs;
        console.log("daaaal",this.rows);
        this.rawdata = rs;
        this.page = 1;

        // Comprobamos si alguno de los clientes tiene un ID en la lista de Ventas
        debugger
        this.isButtonDisabled = this.rows.some(agent => agent.existCommission);
        this.cargaExcel = this.rows.some(agent => agent.existCommission);

        if (this.c_obj['agrAllAnalysis'] == 0){
          this.c_obj['TotalGlobal'] = this.rows.filter(item => item.Amount > 0)
            .reduce((sum, current) => sum + current.Amount, 0);
        }else {
          this.c_obj['TotalGlobal'] = this.rows.filter(item => item.Total > 0)
            .reduce((sum, current) => sum + current.Total, 0);
          // this.c_obj['Data'] = this.rows
        }
        // this.cdRef.detectChanges();
        // this.zone.run(() => {
        //   this.rows = [...this.rows]; // Cambiar la referencia
        //   this.cdRef.detectChanges();
        // }); // Forzar la detección de cambios

        if( Array.isArray(this.rows) ){
          this.pageTotal = this.rows.length;
        }

      }
      else{
        this.rows = [];
        return;
      }
    });
  }

  downloadDocFile(data) {
    const name = data;
    this.srv.downloadFile(data).subscribe((file) => {
      importedSaveAs(file, name)//DocFileName)
    });
  }

}
